import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, message, Dropdown, Menu, Tooltip } from 'antd';
import classNames from 'classnames';
import { UserInfo } from '../../redux/type';
import { RootState } from '../../redux/store';
import { getNewPermissionTabs, getPermissionById, isEmpty } from '../../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { DownOutlined, UserSwitchOutlined } from '@ant-design/icons';
import avatarURL from '../../assets/img/header/nav/avatar.png';
import qs from 'qs';
import { passportExit } from '../../utils/passportLogin';
import { request } from '../../fetch/core';
import { api } from '../../fetch/bussiness/api';
import { HttpStatusCode } from '../../fetch/core/constant';
import { actionClearCockpitInfo } from '@/redux/action';
import SwitchBoard from './components/SwitchBoard';
import { sendGlobalEvent } from '@/utils/emit';
import {
  ChannelType,
  CLSTAG,
  CockpitMode,
  CockpitStatus,
  CockpitType,
} from '@/utils/constant';
import { ChangeCockpitStatus } from '@/fetch/bussiness/ChangeCockpitStatus';
import { showModal } from '@/components/Common/Modal';
import SwitchInfo from './SwitchInfo';
import { clstagStr } from '@/utils/util';
import { Method } from '@/fetch/core/util';
import { reportSgmEvent, SgmEventType } from '@/utils/sgm';

type TabItem = {
  key: string;
  label: string;
  navigator: string;
  clstag: string;
};

const CockpitBtnStatusTitleMap = new Map([
  [CockpitStatus.REST, '休息中'],
  [CockpitStatus.WORK, '工作中'],
]);
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cockpitStatusApi = new ChangeCockpitStatus();
  const [tabList, setTabList] = useState<TabItem[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const [productList, setProductList] = useState<any[]>([]);
  const login = useSelector((state: RootState) => state.login);
  const {
    cockpitMode,
    cockpitStatus,
    cockpitTeamNumber,
    currentCockpit,
    mqttToken,
  } = useSelector((state: RootState) => state.cockpitInfo);

  const [isRemoteControl, setIsRemoteControl] = useState(false);
  const query = qs.parse(window.location.search.split('?')[1]);
  const license = query && query.license;
  const router = useLocation();
  const [switchModeShow, setSwitchModeShow] = useState<boolean>(false);
  const [isChooseCockpit, setIsChooseCockpit] = useState<boolean>(false);

  useEffect(() => {
    const tabs = getNewPermissionTabs();
    setTabList(tabs);
    if (isEmpty(tabs) && router.pathname.indexOf('/app/403') > -1) {
      return;
    } else {
      let idx = tabs.findIndex(
        (item: any) => router.pathname.indexOf(item.navigator) > -1,
      );

      if (router.pathname.indexOf('/app/single') > -1) {
        idx = 0;
      } else if (router.pathname.indexOf('/app/eventplayback') > -1) {
        idx = 3;
      }
      setActiveTab(idx);
      setIsRemoteControl(router.pathname.indexOf('/app/remoteControl') > -1);
      if (location.pathname === '/app/chooseCockpit') {
        setIsChooseCockpit(true);
        mqttToken &&
          sendGlobalEvent('CREATE_MQTT_CLIENT', {
            token: mqttToken,
          });
      } else {
        setIsChooseCockpit(false);
      }
    }
  }, [router, login.resourceList, mqttToken]);

  useEffect(() => {
    if (!isEmpty(login.resourceList)) {
      const prodList = [
        getPermissionById('spv_pda_page') && { label: 'PDA', value: 'pda' },
        getPermissionById('spv_realtime') && {
          label: '智能车',
          value: 'vehicle',
        },
        getPermissionById('tab_warehouse') && {
          label: '多合一',
          value: 'warehouse',
        },
      ].filter(Boolean);
      setProductList(prodList);
    }
  }, [login.resourceList]);
  const handleClick = (index: number, e: any) => {
    if (isChooseCockpit) {
      return;
    }
    const { key, navigator } = tabList[index];
    if (key === 'remoteControl') {
      window.history.go(-1);
    } else if (key === 'dataMonitor') {
      window.open(navigator, '_blank');
    } else {
      setActiveTab(index);
      navigate(navigator);
    }
  };

  // 上报退出登录埋点。result: 'success' 表示本地退出流程已发起（passport 登出 ajax 结果未知），'failure' 表示被 cockpit 退出接口拦截。
  const reportLogout = (result: string, reason?: string) => {
    reportSgmEvent({
      type:
        result === 'success' ? SgmEventType.INFO : SgmEventType.ERROR,
      code: 'monitor_logout',
      msg: {
        page: router.pathname,
        userName: login?.userName || '',
        action: 'logout',
        trigger: 'click',
        requestId: null,
        result,
        ...(reason && { reason }),
        inCockpit:
          cockpitStatus === CockpitStatus.REST ||
          cockpitStatus === CockpitStatus.WORK,
      },
    });
  };

  const handleLogout = () => {
    if (getPermissionById('spv_cockpitMode')) {
      if (
        cockpitStatus === CockpitStatus.REST ||
        cockpitStatus === CockpitStatus.WORK
      ) {
        cockpitStatusApi.quitCockpit().then((res) => {
          if (res.code === HttpStatusCode.Success) {
            reportLogout('success');
            passportExit();
            sendGlobalEvent('CLOSE_MQTT_CLIENT', { isLogout: true });
            localStorage.setItem('logout', 'logout');
          } else {
            reportLogout('failure', res.message);
            message.error(res.message);
          }
        });
      } else {
        reportLogout('success');
        passportExit();
        sendGlobalEvent('CLOSE_MQTT_CLIENT', { isLogout: true });
        localStorage.setItem('logout', 'logout');
      }
    } else {
      reportLogout('success');
      passportExit();
      localStorage.setItem('logout', 'logout');
    }
  };

  const loginOutRemoteControlClick = () => {
    reportSgmEvent({
      type: SgmEventType.INFO,
      code: 'monitor_remote_control_function',
      msg: {
        page: 'remote_control',
        vehicleName: typeof license === 'string' ? license.trim() : '',
        action: 'exit_remote_control',
        trigger: 'click',
        requestId: null,
        result: 'navigated',
      },
    });
    setIsRemoteControl(false);
    navigate(`/app/single?license=${license}`);
  };

  const goChooseCockpit = async (e: any) => {
    e.stopPropagation();
    if (isChooseCockpit) {
      navigate('/app/realtime');
      sendGlobalEvent('CLOSE_MQTT_CLIENT');
      setIsChooseCockpit(false);
      dispatch(actionClearCockpitInfo());
    } else if (cockpitMode === CockpitMode.MONITOR) {
      const resp = await request({
        method: Method.POST,
        path: '/monitor/web/user/getCockpitStatus',
      });
      if (
        resp.code === HttpStatusCode.Success &&
        resp.data?.cockpitTeamNumber &&
        resp.data?.cockpitType === CockpitType.COCKPIT_SEAT
      ) {
        message.error(
          `您已入座${resp?.data?.cockpitNumber}座席，请退出座席后再重新入座`,
        );
        return;
      }
      const res = await cockpitStatusApi.checkUserTakeOver();
      if (res.code !== HttpStatusCode.Success) {
        showModal({
          width: 600,
          content: <p>{res.message}</p>,
          footer: {
            showOk: true,
            okFunc: (cb) => {
              cb();
            },
          },
        });
        return;
      }
      navigate('/app/chooseCockpit');
      setIsChooseCockpit(true);
    }
  };

  const handlClickCockpit = async (e: any) => {
    e.stopPropagation();
    if (cockpitMode !== CockpitMode.MONITOR) {
      setSwitchModeShow(!switchModeShow);
      return;
    }
  };
  const changeSwitchBoardShow = () => {
    setSwitchModeShow(false);
  };
  const getCockpitBtnName = () => {
    if (cockpitStatus === CockpitStatus.OFFLINE) {
      return isChooseCockpit ? '返回' : '座席模式';
    }
  };

  const renderMonitorMode = () => {
    if (cockpitTeamNumber?.length > 0 && getPermissionById('spv_cockpitMode')) {
      return (
        <div className='change-cockpit-btn' onClick={(e) => goChooseCockpit(e)}>
          <div className='btn-icon'></div>
          <span>{getCockpitBtnName()}</span>
        </div>
      );
    } else {
      return <></>;
    }
  };

  const renderCockpitMode = () => {
    return (
      <div
        className='cockpitmode-header'
        onClick={(e) => handlClickCockpit(e)}
        clstag={clstagStr(CLSTAG.ClickCockpitId)}
      >
        <div className='mode-header-icon'></div>
        <span className='cockpit-number'>{currentCockpit.cockpitNumber}</span>
        <div
          className={classNames('cockpit-status-tag', {
            work: cockpitStatus === CockpitStatus.WORK,
          })}
        >
          <i
            className={classNames('cockpit-status-icon', {
              work: cockpitStatus === CockpitStatus.WORK,
            })}
          ></i>
          <span
            className={classNames('cockpit-status', {
              work: cockpitStatus === CockpitStatus.WORK,
            })}
          >
            {CockpitBtnStatusTitleMap.get(cockpitStatus)}
          </span>
        </div>
      </div>
    );
  };

  const renderTab = () => {
    if (isRemoteControl) {
      return (
        <Button
          className='btn-customize loginOut-remoteControl'
          type='primary'
          onClick={loginOutRemoteControlClick}
        >
          <img src={require('../../assets/img/login/logoutOut.png')}></img>
          <span>退出远程遥控</span>
        </Button>
      );
    } else {
      return (
        <>
          <ul className='header-nav'>
            {tabList.map((item: TabItem, index: number) => {
              return (
                <li
                  key={index}
                  onClick={handleClick.bind(null, index)}
                  className={classNames('nav-item-btn', {
                    isActive: activeTab === index,
                    hidden: cockpitMode === CockpitMode.PATROL_MODE,
                  })}
                >
                  {item.label}
                </li>
              );
            })}
          </ul>
          {cockpitMode === CockpitMode.MONITOR
            ? renderMonitorMode()
            : renderCockpitMode()}

          {switchModeShow && (
            <SwitchBoard
              show={switchModeShow}
              changeSwitchBoardShow={changeSwitchBoardShow}
            />
          )}
          <Dropdown
            overlay={menu}
            trigger={['click']}
            arrow
            placement='bottomRight'
          >
            <div className='dropdown-link'>
              <img src={avatarURL} alt='用户头像' className='user-avatar'></img>
              <span className='user-name'>{login.userName}</span>
              <DownOutlined className='down-icon' />
            </div>
          </Dropdown>
        </>
      );
    }
  };

  const menu = (
    <div className='switch-container'>
      <SwitchInfo
        title='产品'
        curSelect='vehicle'
        imgSrc={require('@/assets/img/product-icon.png')}
        list={productList}
        onSelect={(v) => {
          if (v === 'warehouse') {
            window.open('/warehouse', '_blank');
          } else if (v === 'pda') {
            window.open('/pda', '_blank');
          }
        }}
      />
      <div className='logout-btn' key='logout' onClick={handleLogout}>
        退出登录
      </div>
    </div>
  );
  return (
    <div className='fbox cbox page-header'>
      <div className='logo'>
        <i className='logo-icon'></i>
      </div>
      {renderTab()}
    </div>
  );
};

export default Header;
